<template>
  <div class="category">
    <div class="container" :class="{active: !loading}" v-if="!loadingQuery">
        <template v-if="category">
          <header>
            <span>Category</span>
            <h1>{{ category.name }}</h1>
            <p>{{ category.description }}</p>
          </header>
          <transition name="fade">
            <Loading :progress="progress" v-if="loading"/>
          </transition>
          <div class="gallery" v-images-loaded:on.progress="imageProgress">
            <DisplayImage v-for="({ sourceUrl, srcSet, altText }, i) in category.mediaItems.nodes"
              :key="i"
              :src="sourceUrl"
              :srcset="srcSet"
              :alt="altText"
              :active="!loading"/>
          </div>
        </template>
        <template v-else>
          <header class="active">
            <span>This category does not exist</span>
            <h1>404 Error</h1>
          </header>
        </template>
    </div>
  </div>
</template>

<script>
import { useQuery, useResult } from '@vue/apollo-composable'
import { CATEGORY } from '../queries'

import DisplayImage from '../components/DisplayImage'
import Loading from '../components/Loading'

import { useImageLoading } from '../compositions/useImageLoading'
import { computed } from '@vue/composition-api'

export default {
  name: 'Category',
  components: {
    Loading,
    DisplayImage
  },
  head: {
    title() {
      return {
        inner: this.title
      }
    },
  },
  setup(props, { root: { $route } }) {
    const { id } = $route.params
    const title = computed(() => id.toUpperCase())

    const { result, loading: loadingQuery } = useQuery(CATEGORY, { id })
    const category = useResult(result, null, data => data.category)

    const [ progress, loading, imageProgress ] = useImageLoading()

    return {
      title,
      progress, 
      loading, 
      imageProgress,
      loadingQuery,
      category
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    @extend %container;

    margin-top: 8rem;
  }

  span {
    @extend %font-regular;
    line-height: 0.4rem;
    font-size: 0.4rem;
    letter-spacing: 0.5rem;
    transition: opacity 0.8s $ease-out, letter-spacing 1s $ease-out;
    opacity: 0;

    .active & {
      opacity: 1;
      letter-spacing: 0.2rem;
    }
  }

  h1 {
    @extend %font-bold;

    font-size: 3rem;
    line-height: 2.5rem;
    margin-bottom: 0.5rem;
    opacity: 0;
    color: $red;
      
    letter-spacing: 0.5rem;
    transition: opacity 0.8s 0.4s $ease-out, letter-spacing 1s 0.4s $ease-out;

    .active & {
      opacity: 1;
      letter-spacing: 0;
    }
  }

  p {
    opacity: 0;
    transition: opacity 0.8s 1s $ease-out;

    .active & {
      opacity: 1;
    }
  }
</style>